<template>
    <div class="underLogoPhrase">
        <h2 class="font-weight-bold mb-4 centers">Foire aux questions</h2>
      
    </div>
    <div class="container">
    <div class="faq-list">
      <div v-for="item in services" :key="item.id" class="faq-item">
        <input type="checkbox" :id="'faq-'+item.id" class="faq-toggle" />
        <label :for="'faq-'+item.id" class="faq-question">
          {{ item.titre }}
          <span class="chev">▾</span>
        </label>
        <div class="faq-answer" v-html="item.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      services: [],
    };
  },
  mounted() {
    const idSite = this.$idSite ;
    fetch(`https://admin.asso-refuge.fr/getFaqs/${idSite}`)
      .then((res) => res.json())
      .then((data) => {
        this.services = data.map((item) => ({
          id: Number(item.id),
          titre: item.titre,
          content: item.content,
        }));
      })
      .catch((err) => console.error("Erreur de requête :", err));
  },
};
</script>

<style scoped>
.faq-page {
  max-width: 800px;
  margin: 0 auto;
  padding: 80px 20px;
  font-family: Arial, sans-serif;
}

.faq-title {
  text-align: center;
  margin-bottom: 40px;
  font-size: 2rem;
  font-weight: bold;
}

.faq-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.faq-item {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  overflow: hidden;
}

.faq-toggle {
  display: none;
}

.faq-question {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 20px;
  cursor: pointer;
  font-weight: 600;
  transition: background 0.3s ease;
}

.faq-question:hover {
  background: #f0f0f0;
}

.chev {
  transition: transform 0.3s ease;
}

/* Toggle CSS */
.faq-toggle:checked + .faq-question .chev {
  transform: rotate(180deg);
}

.faq-answer {
  max-height: 0;
  overflow: hidden;
  padding: 0 20px;
  transition: max-height 0.3s ease, padding 0.3s ease;
  font-size: 0.95rem;
  line-height: 1.5;
  color: #333;
  opacity: 1 !important;
}

.faq-answer {
  max-height: 0;
  overflow: hidden;
  transition: max-height .4s ease;
}

.faq-toggle:checked ~ .faq-answer {
  max-height: 4000px; /* assez grand */
}
</style>
